export default __webpack_public_path__ + "static/media/screenshot1.6d9dfe2c.jpg";